import React from 'react';
import { colorPalette } from '@lib/constants';

const AvatarBadge = ({ name, index }) => {
  return (
    <div
      key={index}
      className="w-[38px] h-[38px] rounded-full flex justify-center items-center relative"
      style={{
        backgroundColor: colorPalette[index % colorPalette.length],
        marginRight: '-12px',
        zIndex: index,
      }}
    >
      <div className="text-[#212121] text-sm font-semibold font-['Inter'] leading-tight">
        {name}
      </div>
    </div>
  );
};

export default AvatarBadge;
